import { Link } from 'react-router-dom';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { ChevronRight } from 'lucide-react';
import type { NextStepResult } from '@/lib/producer/getNextStep';

interface NextStepCardProps {
  step: NextStepResult;
  basePath: string;
}

export function NextStepCard({ step, basePath }: NextStepCardProps) {
  const Icon = step.icon;

  return (
    <Card className="border-border/60 bg-card shadow-none mb-6">
      <CardContent className="flex items-start gap-3 p-4">
        <div className="mt-0.5 rounded-lg bg-muted p-2.5 shrink-0">
          <Icon className="h-4 w-4 text-muted-foreground" />
        </div>
        <div className="flex-1 min-w-0">
          <p className="text-sm font-medium text-foreground leading-snug">{step.titleSv}</p>
          <p className="text-xs text-muted-foreground mt-0.5 leading-snug">{step.bodySv}</p>
        </div>
        <Button variant="outline" size="sm" className="shrink-0 h-8 text-xs gap-1" asChild>
          <Link to={`${basePath}${step.hrefSuffix}`}>
            {step.ctaLabelSv}
            <ChevronRight className="h-3.5 w-3.5" />
          </Link>
        </Button>
      </CardContent>
    </Card>
  );
}
